<div class="full-width" fxLayout="column">
  <div fxLayout="row" fxFlexOffset="20px">
    <span class="subtitle-default">Rates and Charges</span>
    <div fxLayoutGap="10px" fxFlexOffset="30px">
      <button (click)="addPricingPeriod()" class="button-action" mat-flat-button [disabled]="loader.loading$ | async">
        <div class="button-text">Add</div>
      </button>
      <button (click)="editPricingPeriod()" *ngIf="!pricingPeriodSelection.isEmpty()" class="button-action"
              [disabled]="loader.loading$ | async"
              mat-flat-button>
        <div class="button-text">Edit</div>
      </button>
      <button (click)="removePricingPeriod()"
              *ngIf="!pricingPeriodSelection.isEmpty() && pricingPeriodSelection.selected[0].isEditable"
              class="button-action" mat-flat-button [disabled]="loader.loading$ | async">
        <div class="button-text">Remove</div>
      </button>
    </div>
  </div>

  <div class="radius-10 bg-white mat-elevation-z3" fxLayout="column" fxFlexOffset="30px">

    @if (leasePricingPeriodDataSource.data.length > 0) {
      <table [dataSource]="leasePricingPeriodDataSource" class="custom-table" fxFlex="50" mat-table>
        <ng-container matColumnDef="table-label">
          <th *matHeaderCellDef [attr.colspan]="pricingPeriodDisplayedColumns.length" class="custom-table-label"
              mat-header-cell>
            Lease Pricing Period Config
          </th>
        </ng-container>

        <ng-container matColumnDef="select">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let row" class="custom-table-cell" mat-cell>
            <mat-checkbox (change)="$event ? setSelectedPricingPeriod(row) : null"
                          (click)="$event.stopPropagation()"
                          [checked]="pricingPeriodSelection.isSelected(row)"
                          color="primary">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="uuid">
          <th *matHeaderCellDef mat-header-cell> ID</th>
          <td *matCellDef="let element" class="custom-table-cell" mat-cell> {{ utils.displayUuid(element.uuid) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="rentalPricingOption">
          <th *matHeaderCellDef mat-header-cell>Rental Type</th>
          <td *matCellDef="let element" class="custom-table-cell"
              mat-cell>{{ getRentalType(element.rentalPricingOption) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fixedRentalPricingValue">
          <th *matHeaderCellDef mat-header-cell>Rental Fee</th>
          <td *matCellDef="let element" class="custom-table-cell"
              mat-cell>{{ utils.displayRandAmountWithDecimal(element.fixedRentalPricingValue) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="rentalPricingTurnoverPercentageValue">
          <th *matHeaderCellDef mat-header-cell>Turnover Fee</th>
          <td *matCellDef="let element" class="custom-table-cell"
              mat-cell>{{ utils.displayNumber(element.rentalPricingTurnoverPercentageValue) }} %
          </td>
        </ng-container>

        <ng-container matColumnDef="applyTransactionFee">
          <th *matHeaderCellDef mat-header-cell>Apply Transaction Fees</th>
          <td *matCellDef="let element" class="custom-table-cell"
              mat-cell>{{ element.applyTransactionFee ? 'Yes' : 'No' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="startDate">
          <th *matHeaderCellDef mat-header-cell>Start Date</th>
          <td *matCellDef="let element" class="custom-table-cell"
              mat-cell> {{ displayDate(element.startDate) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="endDate">
          <th *matHeaderCellDef mat-header-cell>End Date</th>
          <td *matCellDef="let element" class="custom-table-cell"
              mat-cell> {{ displayDate(element.endDate) }}
          </td>
        </ng-container>


        <tr *matHeaderRowDef="['table-label']" class="custom-table-header" mat-header-row></tr>
        <tr *matHeaderRowDef="pricingPeriodDisplayedColumns" class="custom-table-header" mat-header-row></tr>
        <tr (click)="setSelectedPricingPeriod(row)" *matRowDef="let row; columns: pricingPeriodDisplayedColumns;"
            [class.selected-row]="selectedPricingPeriodUuid === row.uuid"
            class="custom-table-row btn-cursor"
            mat-row></tr>
      </table>
    } @else {
      <app-info-panel [type]="PanelType.INFO"
                      [message]="['Lease does not have any rates and charges information']"></app-info-panel>
    }

  </div>
</div>
